/**
 * Auth Store Actions
 * All authentication state mutations go through here
 *
 * Part of Phase 2: State Management Consolidation
 * @version 1.0.0
 */

let Store = null;

function getStore() {
  if (!Store) {
    Store = window.Store;
  }
  if (!Store) {
    console.warn('[AuthActions] Store not available yet');
  }
  return Store;
}

function safeSet(path, value) {
  const store = getStore();
  if (store) {
    store.set(path, value);
    return true;
  }
  return false;
}

function safeGet(path, defaultValue) {
  const store = getStore();
  return store ? store.get(path) : defaultValue;
}

/**
 * Set authenticated user
 * @param {Object} user
 */
export function setUser(user) {
  safeSet('auth.user', user);
  safeSet('auth.isAuthenticated', !!user);
  safeSet('auth.loading', false);
}

/**
 * Set user profile
 * @param {Object} profile
 */
export function setProfile(profile) {
  safeSet('auth.profile', profile);
}

/**
 * Update user credits
 * @param {number} credits
 */
export function setCredits(credits) {
  const user = safeGet('auth.user', null);
  if (user) {
    safeSet('auth.user', { ...user, credits });
  }
}

/**
 * Deduct credits
 * @param {number} amount
 */
export function deductCredits(amount) {
  const user = safeGet('auth.user', null);
  if (user && typeof user.credits === 'number') {
    const newCredits = Math.max(0, user.credits - amount);
    safeSet('auth.user', { ...user, credits: newCredits });
  }
}

/**
 * Add credits
 * @param {number} amount
 */
export function addCredits(amount) {
  const user = safeGet('auth.user', null);
  if (user && typeof user.credits === 'number') {
    const newCredits = user.credits + amount;
    safeSet('auth.user', { ...user, credits: newCredits });
  }
}

/**
 * Set auth loading state
 * @param {boolean} loading
 */
export function setLoading(loading) {
  safeSet('auth.loading', loading);
}

/**
 * Set auth error
 * @param {string|null} error
 */
export function setError(error) {
  safeSet('auth.error', error);
}

/**
 * Clear auth state (logout)
 */
export function clearAuth() {
  safeSet('auth', {
    user: null,
    profile: null,
    isAuthenticated: false,
    loading: false,
    error: null
  });
}

/**
 * Initialize actions - register with Store
 */
export function initActions() {
  const store = getStore();
  if (!store) {
    console.warn('[AuthActions] Store not available yet');
    return;
  }

  store.registerAction('auth/setUser', setUser);
  store.registerAction('auth/setProfile', setProfile);
  store.registerAction('auth/setCredits', setCredits);
  store.registerAction('auth/deductCredits', deductCredits);
  store.registerAction('auth/addCredits', addCredits);
  store.registerAction('auth/setLoading', setLoading);
  store.registerAction('auth/setError', setError);
  store.registerAction('auth/clear', clearAuth);
  store.registerAction('auth/logout', clearAuth);

  console.log('[AuthActions] Registered with Store');
}

export default {
  setUser,
  setProfile,
  setCredits,
  deductCredits,
  addCredits,
  setLoading,
  setError,
  clearAuth,
  initActions
};
